import React from 'react';
import { TableRow, Tooltip } from '@mui/material';
import { TableCellBody } from '../table/tableCell';

interface TableRowItemProps {
    row: any;
    tab?: string;
    cumulative?: number;
}

const TableRowItem: React.FC<TableRowItemProps> = ({ row, tab, cumulative }) => {
    const tableRow = (
        <TableRow
            key={row.email}
            sx={{
                '&:last-child td, &:last-child th': { borderBottom: 0 },
                backgroundColor: 'none',
            }}
        >
            <TableCellBody>{row.name || '-'}</TableCellBody>
            <TableCellBody>{row.tasks || 0}</TableCellBody>
            {/* <TableCellBody>{row.also_unallocated_from && row.also_unallocated_from.length > 0
                ? row.also_unallocated_from.join(', ')
                : '-'}</TableCellBody> */}
        </TableRow>
    );

    return tableRow
};

export default TableRowItem;
